module.exports = __webpack_public_path__ + "574fb287065d2034a915c52133601f7b.svg";